import React, { useMemo, useEffect, useState, useCallback } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../../components/AuthingButton";

export const AuthorityFeature = () => {
  const { t } = useTranslation();
  const features = [
    {
      layout: "",
      title: t("authority.advantage.item5.title"),
      subtitle: t("authority.advantage.item5.descript"),
      lists: [
        t("authority.advantage.item5.data1"),
        t("authority.advantage.item5.data2"),
        t("authority.advantage.item5.data3"),
        t("authority.advantage.item5.data4"),
      ],
      downText: t("common.button.consult"),
      img: t("authority.advantage.item5.img"),
      downUrl: "https://www.authing.cn/authingform?fromTag=权限管理",
    },
    {
      layout: "reverse",
      title: t("authority.advantage.item6.title"),
      subtitle: t("authority.advantage.item6.descript"),
      lists: [
        t("authority.advantage.item6.data1"),
        t("authority.advantage.item6.data2"),
        t("authority.advantage.item6.data3"),
        t("authority.advantage.item6.data4"),
      ],
      downText: t("common.button.linkDoc"),
      img: t("authority.advantage.item6.img"),
      downUrl:
        "https://docs.authing.cn/v3/reference/mobile/sdk-for-csharp/management/AclManagementClient.html",
    },
  ];
  return (
    <div className="authority-feature">
      {features.map((feature) => (
        <div className={`authority-feature-warp ${feature.layout}`}>
          <div className="authority-feature-img">
            <img
              src={`//files.authing.co/authing-website/${feature.img}`}
              alt="authing"
            />
          </div>
          <div className="authority-feature-content">
            <div className="authority-feature-title">{feature.title}</div>
            <div className="authority-feature-subtitle">{feature.subtitle}</div>
            <div className="authority-feature-list-warp">
              {feature.lists.map((list) => (
                <div className="authority-feature-list">
                  <span className="authority-feature-list-icon">
                    <i className="icon authing-icon authing-check-line"></i>
                  </span>
                  {list}
                </div>
              ))}
            </div>
            <AuthingButton
              mode="small"
              onClick={() => {
                window.open(feature.downUrl);
              }}
            >
              {feature.downText}
            </AuthingButton>
          </div>
        </div>
      ))}
    </div>
  );
};
